<template>
    <form>
        <ValidationObserver ref="observer" v-slot="{ passes }">
                <div class="modal-card">
                    <header class="modal-card-head">
                        <p class="modal-card-title">
                            Add a new Todo
                        </p>
                        <b-icon icon="pen"></b-icon>
                    </header>
                    <div class="modal-card-body">
                        <ValidationProvider name="Art" rules="required" v-slot="{ errors, valid }">
                            <b-field label="Type of Todo" :type="{'is-danger':errors[0], 'is-success': valid}"
                                :message="errors[0]">
                                <b-input v-model="todosInput.Art" icon="keyboard" ref="type"></b-input>
                            </b-field>
                        </ValidationProvider>

                        <ValidationProvider name="Person" rules="required" v-slot="{ errors, valid }">
                            <b-field label="Contact Person" :type="{'is-danger':errors[0]&&todosInput.Art, 'is-success': valid}"
                                :message="errors[0]">
                                <b-autocomplete
                                    v-model="todosInput.Person"
                                    ref="autocomplete"
                                    :data="filteredUsersArray"
                                    placeholder="e.g. Fritz"
                                    @select="option => selected = option"
                                    open-on-focus
                                    icon="user"
                                    key="Person"
                                    :disabled="!todosInput.Art">
                                    <template slot="empty">No one named {{todosInput.Person}} here.</template>
                                </b-autocomplete>
                            </b-field>
                        </ValidationProvider>

                        <ValidationProvider name="Raum" rules="required" v-slot="{ errors, valid }">
                            <b-field label="Room" :type="{'is-danger':errors[0]&&todosInput.Person, 'is-success': valid}"
                                :message="errors[0]">
                                <b-input v-model="todosInput.Raum" :disabled="!todosInput.Person" icon="building"></b-input>
                            </b-field>
                        </ValidationProvider>

                        <ValidationProvider name="Rechner" rules="required" v-slot="{ errors, valid }">
                            <b-field label="Computer" :type="{'is-danger':errors[0]&&todosInput.Raum, 'is-success': valid}"
                                :message="errors[0]">
                                <b-input v-model="todosInput.Rechner" :disabled="!todosInput.Raum" icon="desktop"></b-input>
                            </b-field>
                        </ValidationProvider>

                        <ValidationProvider name="Details" rules="required" v-slot="{ errors, valid }">
                            <b-field label="Details" :type="{'is-danger':errors[0]&&todosInput.Rechner, 'is-success': valid}"
                                :message="errors[0]">
                                <b-input maxlength="200" type="textarea" v-model="todosInput.Details" :disabled="!todosInput.Rechner"></b-input>
                            </b-field>
                        </ValidationProvider>
                    </div>

                    <footer class="modal-card-foot">
                        <b-button @click="clear" style="margin-right:auto;" icon-left="strikethrough" type="is-danger">Clear</b-button>
                        <b-button @click="close" style="margin-left:auto;" icon-left="times-circle" type="is-light">Cancel</b-button>
                        <b-button @click.prevent="passes(addTodo)" icon-left="save" type="is-primary">Save
                        </b-button>
                    </footer>
                </div>
        </ValidationObserver>
    </form>
</template>

<script>
import {
  extend
} from 'vee-validate';
import {
  required, email
} from 'vee-validate/dist/rules';

// Add the rules
extend('email', email);
extend('required', {
  ...required,
  message: 'Nicht vergessen…'
});

import {
  ValidationObserver,
  ValidationProvider
} from 'vee-validate'
export default {
    data() {
        return {
            todosInput: {
                "Art": "",
                "Details": "",
                "Person": "",
                "Raum": null,
                "Rechner": "",
            },
        }
    },
    props: ['users'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    computed: {
        nowDate() {
            let currentDate = new Date
            let dateString
            let year    = currentDate.getFullYear();
            let month   = currentDate.getMonth() + 1;
            let day     = currentDate.getDate();
            dateString = year + '.' + month + '.' + day
            return dateString
        },
        filteredUsersArray() {
            return this.users.filter((option) => {
                return option
                    .toString()
                    .toLowerCase()
                    .indexOf(this.todosInput.Person.toLowerCase()) >= 0
            })
        },
        userName() {
            return this.$store.getters.getUserName
        }
    },
    methods: {
        addTodo() {
            let currentDateSend = this.dateToString()
            let currentDateShow = this.dateToHuman()
            this.$buefy.dialog.confirm({
                title: 'Eingaben nochmals überprüfen',
                message: '<table class="table is-striped is-fullwidth"><tbody><tr><th>Date</th><td> ' + currentDateShow +'</td></tr><tr><th>Type</th><td>' + this.todosInput.Art + '</td></tr><tr><th>Contact</th><td>' + this.todosInput.Person + '</td></tr><tr><th>Room</th><td>' + this.todosInput.Raum + '</td></tr><tr><th>Computer</th><td>' + this.todosInput.Rechner + '</td></tr><tr><th>Details</th><td>' + this.todosInput.Details + '</td></tr><tr></tbody></table>',
                confirmText: 'Save',
                type: 'is-success',
                trapFocus: true,
                hasIcon: true,
                icon: 'check-double',
                cancelText: 'Bearbeiten',
                onConfirm: () => {
                    this.todosInput["Date"] = currentDateSend
                    this.todosInput["Completed"] = false
                    this.$store.dispatch("addTodo", this.todosInput)
                    .then(() => {
                        this.$buefy.toast.open({
                            message: 'Added a todo!',
                            type: 'is-success',
                            position: 'is-bottom',
                            duration: 3000
                        })
                    },
                    error => {
                        // Handle Errors here.
                        let errorMessage = error;
                        this.$buefy.toast.open({
                            message: errorMessage,
                            type: 'is-danger',
                            position: 'is-bottom',
                            duration: 6000
                        })
                    })
                    // console.log("closing?")
                    // this.$parent.$emit('close')
                    this.close()
                    // this.clear()
                }
            })
        },

        dateToString() {
            // This format is better for sorting
            // 2016.10.15
            let date = new Date
            let dateString
            let year    = date.getFullYear();
            let month   = date.getMonth() + 1;
            let day     = date.getDate();
            dateString = year + '.' + month + '.' + day
            return dateString
            // return this.date.toString()
        },

        dateToHuman() {
            // Based on locale
            let date = new Date
            let dateHuman = date.toLocaleDateString()
            return dateHuman
        },

        focusInput() {
            this.$refs.type.focus()
        },

        close() {
            // Doesn't get called
            // console.log("Closing...")
            this.$emit('close')
        },
        clear() {
            // Doesn't get called
            // console.log("Clearing...")
            this.todosInput.Art = ""
            this.todosInput.Details = ""
            this.todosInput.Person = ""
            this.todosInput.Raum = ""
            this.todosInput.Rechner = ""
        }
    },
    mounted() {
        this.focusInput()
        if (this.userName) {
            this.todosInput.Person = this.userName
        }
    }
}
</script>

<style scoped>
.modal .animation-content .modal-card {
    margin-left: auto;
    margin-right: auto;
}
</style>